var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8141 19.1156H2.18844C1.40094 19.1156 0.757812 18.4725 0.757812 17.685V6.31502C0.757812 5.52752 1.40094 4.8844 2.18844 4.8844H21.8141C22.6016 4.8844 23.2447 5.52752 23.2447 6.31502V17.685C23.2447 18.4725 22.6016 19.1156 21.8141 19.1156Z",
    fill: "#A07CAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.753906 7.29004H23.2445V10.3032H0.753906V7.29004Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4131 13.9012H2.60125C2.4175 13.9012 2.26562 13.7512 2.26562 13.5656V11.9887C2.26562 11.805 2.41563 11.6531 2.60125 11.6531H12.0072H21.4131C21.5969 11.6531 21.7488 11.8031 21.7488 11.9887V13.5656C21.7469 13.7493 21.5969 13.9012 21.4131 13.9012Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 13.2168C4.60109 13.0143 4.62922 12.7781 4.72297 12.57C4.81672 12.3618 5.02109 12.1687 5.24609 12.2043C5.45422 12.2381 5.58359 12.4462 5.66047 12.6412C5.76734 12.9131 5.82547 13.2037 5.83297 13.4962C5.83484 13.5562 5.83109 13.6218 5.79172 13.6687C5.72234 13.7475 5.57984 13.7081 5.52547 13.6181C5.47109 13.5281 5.48422 13.4137 5.50859 13.3106C5.62484 12.8325 5.99984 12.4256 6.46672 12.2718C6.51547 12.255 6.56609 12.2418 6.61672 12.2512C6.72547 12.2718 6.78547 12.3843 6.83422 12.4818C6.94859 12.705 7.08734 12.9168 7.24672 13.11C7.31047 13.1887 7.38359 13.2656 7.48109 13.2956C7.80172 13.3893 7.98734 12.9168 8.29672 12.7912C8.66797 12.6412 9.02984 13.0331 9.42359 13.1062C9.99922 13.2131 10.3048 12.765 10.8092 12.6506C10.8767 12.6356 10.9498 12.6262 11.0173 12.645C11.1411 12.6806 11.218 12.7987 11.2911 12.9056C11.4617 13.1568 11.7055 13.4043 12.0092 13.4062C12.2023 13.4081 12.3805 13.3087 12.5567 13.2243C13.1811 12.9262 13.918 12.8025 14.5705 13.0312",
    stroke: "#424242",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.dc8ab135.svg";
export { ForwardRef as ReactComponent };